import cx from 'classnames';
import { Button as Btn, SimpleText } from 'platform-components';
import React from 'react';

export const Button = () => {
    return (
        <Btn className={cx('side-panel__action-button', 'qa_lesson-completed-button')} disabled>
            <SimpleText id="lessonModal.header.lessonFinished" />
        </Btn>
    );
};

export default Button;
